import { fetchIpData } from './geoip-demo-widget';

const locateMyIp = async () => {
  const ipAddressSection = document.querySelector('.js-ip-address-found');
  const ipAddress = document.querySelector('.js-ip-address');
  const countries = document.querySelectorAll('.js-country');
  const subdivisions = document.querySelectorAll('.js-subdivision');
  const accuracyLevelLessThan100 = document.querySelector(
    '.js-accuracy-level-less-than-100',
  );
  const accuracyLevelMoreThan100 = document.querySelector(
    '.js-accuracy-level-more-than-100',
  );
  const onlyCountry = document.querySelector('.js-only-country');
  const noGeolocation = document.querySelector('.js-no-geolocation');

  try {
    const json = await fetchIpData();

    ipAddressSection?.classList.remove('d-none');
    if (ipAddress) {
      ipAddress.textContent = json?.traits?.ip_address ?? '-';
    }

    if (subdivisions) {
      subdivisions.forEach((subdivision) => {
        subdivision.textContent = json?.subdivisions?.[0]?.names?.en
          ? `${json.subdivisions[0].names.en},`
          : '';
      });
    }

    if (countries) {
      countries.forEach((country) => {
        country.textContent = json?.country?.names?.en ?? '';
      });
    }

    if (json.city || json.subdivisions) {
      if (json.location?.accuracy_radius) {
        if (json.location.accuracy_radius <= 100) {
          accuracyLevelLessThan100?.classList.remove('d-none');
        } else {
          accuracyLevelMoreThan100?.classList.remove('d-none');
        }
      }
    }

    if (!json.city && !json.subdivisions) {
      if (json.country) {
        onlyCountry?.classList.remove('d-none');
      } else {
        noGeolocation?.classList.remove('d-none');
      }
    }
  } catch (error) {
    const noIpAddressFound = document.querySelector('.js-no-ip-address');
    noIpAddressFound?.classList.remove('d-none');
    if (error instanceof Error) {
      console.error('Could not locate IP:', error.message);
    }
    throw error;
  }
};

locateMyIp();
